// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import CommandPaletteController from "./command_palette_controller"
application.register("command-palette", CommandPaletteController)

import InvoiceFormController from "./invoice_form_controller"
application.register("invoice-form", InvoiceFormController)

import CustomFieldsController from "./custom_fields_controller"
application.register("custom-fields", CustomFieldsController)

import ProductSearchController from "./product_search_controller"
application.register("product-search", ProductSearchController)

import ProductFormController from "./product_form_controller"
application.register("product-form", ProductFormController)

import HsCodeSearchController from "./hs_code_search_controller"
application.register("hs-code-search", HsCodeSearchController)

import CustomerFormController from "./customer_form_controller"
application.register("customer-form", CustomerFormController)

import CustomerSearchController from "./customer_search_controller"
application.register("customer-search", CustomerSearchController)

import CustomerModalController from "./customer_modal_controller"
application.register("customer-modal", CustomerModalController)

import NumberingPreviewController from "./numbering_preview_controller"
application.register("numbering-preview", NumberingPreviewController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import FbrUploadController from "./fbr_upload_controller"
application.register("fbr-upload", FbrUploadController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import ViewportRevealController from "./viewport_reveal_controller"
application.register("viewport-reveal", ViewportRevealController)

import ImageRevealController from "./image_reveal_controller"
application.register("image-reveal", ImageRevealController)

import SupplierModalController from "./supplier_modal_controller"
application.register("supplier-modal", SupplierModalController)

import PoFormController from "./po_form_controller"
application.register("po-form", PoFormController)

import RevenueChartController from "./revenue_chart_controller"
application.register("revenue-chart", RevenueChartController)

import BillingToggleController from "./billing_toggle_controller"
application.register("billing-toggle", BillingToggleController)

import BridgeButtonController from "./bridge/button_controller"
application.register("bridge--button", BridgeButtonController)

import BridgeAuthController from "./bridge/auth_controller"
application.register("bridge--auth", BridgeAuthController)

import BridgeThemeController from "./bridge/theme_controller"
application.register("bridge--theme", BridgeThemeController)

import InvoiceSelectionController from "./invoice_selection_controller"
application.register("invoice-selection", InvoiceSelectionController)

import InvoiceBulkController from "./invoice_bulk_controller"
application.register("invoice-bulk", InvoiceBulkController)

import BulkProgressController from "./bulk_progress_controller"
application.register("bulk-progress", BulkProgressController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)
